module.exports = __webpack_public_path__ + "static/media/get_credit.cb48305f.png";